import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import WPAgGrid from "../../packages/WPAgGrid/WPAgGrid";
import WPTertiaryButton from "../../packages/WPTertiaryButton";

import CIPEventDialog from "../CIPEventDialog/CIPEventDialog";
import { CIP_TABLE_CONFIG } from "../CIPSpecification/CIPTable.config";
// import WPPagination from "../../packages/WPPagination";
import createNotification, { ERROR_NOTIFICATION } from "../Notifications";

import {
  CIP_SOURCE_OPTIONS,
  // PAGE_SIZE_OPTIONS,
  DEFAULT_PAGE_SIZE_OPTION,
} from "../../constants/global.constants";

import { ErrorIcon, PlusIcon } from "../../assets/icons";

import CircularLoader from "../../common/styles/components/circularLoader";

import { getCIPs } from "../../network/cipAPI";

import { storeCIPS } from "../../Store/TemplateStore/template.action";

import "./CIPPaginatedTable.scss";

// commented pagination code as it is not being used currently. It can be added back if needed in future.
const CIPPaginatedTable = ({
  selectedTrain,
  exportFileName,
  resetCIPMode,
  isScrollIntoView = false, // no scroll into view by default
  source = null, // all CIPs
  errorMessage = null, // No error message by default,
  enableActions = false, // Enable actions column if true
  enableAdd = false, // Enable add button if true
  showTableLoader = false, // Show loader for table
  historicOnly = false, // Flag to determine historic_only CIPs
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { temperature, mass, currency } = useSelector((state) => state);
  const gridRef = useRef(null);

  // const [totalItems, setTotalItems] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const [currentPage, setCurrentPage] = useState(1);
  const currentPage = 1; // remove this & add above if pagination is added back
  // setting 50 as default for temporary
  // const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE_OPTION);
  const pageSize = DEFAULT_PAGE_SIZE_OPTION; // remove this & add above if pagination is added back
  const [showAddDialog, setShowAddDialog] = useState(false);

  const updateStoreCips = (data) => {
    dispatch(storeCIPS([...data]));
  };

  const showLoader = (loading) => {
    setIsLoading(loading);
  };

  const fetchCIPs = async () => {
    showLoader(true);
    try {
      // historic_only is true for CIP identification (activeStep 2), Cleaning effectiveness (activeStep 3), and Fouling type (activeStep 4)
      const response = await getCIPs(
        selectedTrain,
        null, // pageSize
        null, // currentPage
        source,
        historicOnly,
      );
      if (response.status === 200) {
        // setTotalItems(response.data.total_cips);
        const CIPData = response.data.cips;
        updateStoreCips(CIPData);

        // reset when last item is deleted
        if (CIPData.length === 0) {
          setTableData([]);
          resetCIPMode && resetCIPMode();
        } else {
          const srNo = (currentPage - 1) * pageSize;
          const updatedCIPData = CIPData.map((cip, idx) => ({
            ...cip,
            srNo: srNo + idx + 1,
          }));
          setTableData(updatedCIPData);
        }
      }
    } catch (err) {
      setTableData([]);
      createNotification(
        ERROR_NOTIFICATION,
        t("notificationStrings.somethingWrong"),
      );
    } finally {
      showLoader(false);
    }
  };

  useEffect(() => {
    if (selectedTrain) {
      fetchCIPs();
    }
  }, [selectedTrain, pageSize, currentPage]);

  // const handlePageChange = (page, newPageSize) => {
  //   setCurrentPage(page);
  //   if (newPageSize && newPageSize !== pageSize) {
  //     setPageSize(newPageSize);
  //     setCurrentPage(1);
  //   }
  // };

  return (
    <>
      {(isLoading || showTableLoader) && (
        <div className="circular-loader-overlay">
          <CircularLoader />
        </div>
      )}
      {showAddDialog && (
        <CIPEventDialog
          onModalClose={() => setShowAddDialog(false)}
          refreshTable={fetchCIPs}
          source={source}
        />
      )}
      {errorMessage && !isLoading && tableData.length === 0 ? (
        <div className="errorText12 card-error">
          <ErrorIcon />
          {errorMessage}
        </div>
      ) : (
        <div className="cip-table-wrapper">
          {enableAdd && (
            <div className=" flex-between-center">
              <div className="info-section">
                <WPTertiaryButton
                  label={
                    source === CIP_SOURCE_OPTIONS.RECURRENT
                      ? t("CIPEvent.addRecurrentEvents")
                      : t("CIPEvent.addCIP/Shutdown")
                  }
                  onClick={() => setShowAddDialog(true)}
                  icon={<PlusIcon size={16} />}
                  iconPlacement="before"
                  variant="outlined"
                  size="small"
                  className={exportFileName ? "cip-add-export-visible" : ""}
                />
              </div>
            </div>
          )}
          <div className="ro-ag-table">
            <WPAgGrid
              gridRef={gridRef}
              columnDefs={CIP_TABLE_CONFIG(
                t,
                temperature,
                mass,
                currency,
                fetchCIPs,
                showLoader,
                source,
                enableActions,
              )}
              rowData={tableData}
              exportFileName={exportFileName}
              isScrollIntoView={isScrollIntoView}
            />
            {/* <WPPagination
              totalItems={totalItems}
              pageSizeOptions={PAGE_SIZE_OPTIONS}
              currentPage={currentPage}
              pageSize={pageSize}
              onPageChange={handlePageChange}
            /> */}
          </div>
        </div>
      )}
    </>
  );
};

export default CIPPaginatedTable;
